import { IonSpinner } from '@ionic/react';

interface Props {
  backgroundFull?: boolean;
  global?: boolean;
}

export const Loading = ({ backgroundFull = false, global = false }: Props) => {
  return (
    <div className={`full-screen ${backgroundFull ? 'background-full' : ''} ${global ? 'global-loading' : ''}`}>
      <div className="loader-body">
        <IonSpinner name="circular" style={{ width: 32, height: 32 }}></IonSpinner>
      </div>
    </div>
  );
};
